/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { DocumentsListPage } from './DocumentsListPage'
import { DOCUMENTS_VIEW_TYPE } from './types'

export const PeriodicReviewPage: React.FC = () => {
  return <DocumentsListPage key="periodicReview" viewType={DOCUMENTS_VIEW_TYPE.periodicReviewUpcoming} />
}
